import {
  ApplicationInsights,
  type ITelemetryItem,
} from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js'

export interface AppInsightsInstance {
  reactPlugin: ReactPlugin
  appInsights: ApplicationInsights
}

let instance: AppInsightsInstance | null = null

const createAppInsights = (
  connectionString: string | null
): AppInsightsInstance => {
  const clickPluginInstance = new ClickAnalyticsPlugin()

  const clickPluginConfig = {
    autoCapture: true,
    dataTags: {
      useDefaultContentNameOrId: true,
    },
  }

  const reactPlugin = new ReactPlugin()
  const appInsights = new ApplicationInsights({
    config: {
      connectionString:
        connectionString ??
        'InstrumentationKey=00000000-0000-0000-0000-000000000000;EndpointSuffix=ai.contoso.com;',
      extensions: [reactPlugin, clickPluginInstance],
      enableAutoRouteTracking: true,
      disableAjaxTracking: false,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      extensionConfig: {
        [clickPluginInstance.identifier]: clickPluginConfig,
      },
    },
  })

  appInsights.loadAppInsights()
  appInsights.trackPageView()

  appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
    env.tags = env.tags ?? []
    env.tags['ai.cloud.role'] = 'PitBrain'
  })
  return { reactPlugin, appInsights }
}

export const getAppInsights = (
  connectionString: string | null
): AppInsightsInstance => {
  instance ??= createAppInsights(connectionString)
  return instance
}
